require.register("modules/m03/m03-activity/page-6_ca/page-6_ca", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page6_ca = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page6_ca;
  
});

